import React, { FC, useEffect, useState } from 'react'
import styled from 'styled-components'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { CheckMark, CheckMarkContainer } from '../checkMark'

const Container = styled.div<{ $selected?: boolean }>`
    position: relative;

    ${CheckMarkContainer} {
        position: absolute;
        right: 0.5em;
        top: 0.5em;
        display: ${(p) => (p.$selected ? 'block' : 'none')};
    }

    &:hover {
        cursor: pointer;

        ${CheckMarkContainer} {
            display: block;
        }
    }
`

const Image = styled.img`
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
    user-select: none;
`

interface Props {
    url: string
    selected: boolean
    onClick: () => void
    onSelect: () => void
    onError?: () => void
}

export const Attachment: FC<Props> = ({
    url,
    selected,
    onClick,
    onSelect,
    onError,
}) => {
    const [isImageLoaded, setIsImageLoaded] = useState(false)
    const [hasError, setHasError] = useState(false)

    // Reset loading state when the URL changes (e.g. after re-sign)
    useEffect(() => {
        setIsImageLoaded(false)
        setHasError(false)
    }, [url])

    return (
        <Container $selected={selected} onClick={onClick}>
            <Image
                src={url}
                alt="attachment_image"
                onLoad={() => {
                    setIsImageLoaded(true)
                    setHasError(false)
                }}
                onError={() => {
                    setHasError(true)
                    onError?.()
                }}
            />

            <CheckMark selected={selected} onClick={onSelect} />

            {(!isImageLoaded || hasError) && (
                <Skeleton
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        borderRadius: 0,
                    }}
                />
            )}
        </Container>
    )
}
